/*
Sohel  12/19/2022 3075154998 Added data manager Screen Stepper
Sohel  12/19/2022 3075154998 button label Changes.
Lalitha 12/28/2022 3075154998 Add new Component SelectField Stepper
Sohel 01/03/2023 2699714747 Map Record Fields Changes
dilip 01/04/2023 2699714747 Removed selected Fields and Filter Criteria steps
Sohel 01/09/2023 2699714747 Added Filter Criteria Screen
Sohel 01/09/2023 2699714747 changed stepper hide condition
dilip 01/10/2023 2699714747 Added unsaved popup.
Sohel 01/10/2023 2699714747 changed filter criteria condition.
kavyareddy 01/10/2023 2699714747 Added download configuration
Sohel 01/10/2023 2699714747 changed download configuration condition
Sohel 01/12/2023 2699714747 changed download configuration condition
dilip 01/12/2023 2699714747 Added Map Exception Records Step.
dilip 01/12/2023 2699714747 Added condition to Map Exception Records Step for Customer Query.
dilip 01/12/2023 2699714747 Setting Parent Record.
dilip 01/12/2023 2699714747 Added Completed steps functionality.
Sohel 01/19/2023 2699714747 Download Configuration payload changes
dilip 01/20/2023 2699714747 Added Map Exception functionality for IM Record Group
 dilip 01/20/2023 2699714747 Added Last Step functionality
 Lalitha 01/23/2023 2699714747 Changed byDefault to BasicInfo for completed Step
 Lalitha 01/23/2023 2699714747 Fixed stepper issue
 Ashraf 01/31/2023 2699714747 fixed useEffect issue
 Ashraf 01/31/2023 2699714747 fixed active step issue
 suresh peddavoora 02/22/2023 2699714747 New UI changes implemented

Akhila 02/27/2023 2699714747 implemented preview file functionality
Sohel 03/10/2023 2699714747 added StepIconComponent for showing Numbers in StepLabel
Ravi 06/09/2023 2699714747 Added Breadcrums in preview
Akhila 06/12/2023 2699714747 added role access
*/
import {Button, makeStyles, Stepper, StepLabel, Step} from '@material-ui/core';
import React, {useEffect, useRef, useState} from 'react';
import reusableInputStyles from '../../../../../components/InputStyles';
import {backButtonText, downloadButton} from '../../../../../util/Content';
import {ArrowBack} from '@material-ui/icons';
import StepConnector from '@material-ui/core/StepConnector';
import {withStyles} from '@material-ui/core/styles';
import DMBasicInfo from './DMBasicInfo';
import DMFilterCriteria from '../../DataManagerRecord/AddDataManagerRecord/DMRFilterCriteria';
import DMSelectField from './DMSelectField';
import MapRecordGroup from './MapRecordGroup';
import {useDispatch, useSelector} from 'react-redux';
import useUnsavedChangesWarning from './../../../../../util/CustomHooks';
import {setAlertData} from '../../../../../redux/reducers/UnsavedChangesAlertReducer';
import moment from 'moment';
import {
  postPrintImportMaster,
  getRecordMapData,
  setParentRecordException,
  resetConfigUrl,
  resetDockey,
} from '../../../../../redux/reducers/DataManager';
import MapExceptionRecord from './MapExceptionRecord';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import axios from 'axios';
import PageLoader from '../../../../../components/PageLoader';
import NumberStepIcon from '../../../../../components/customStepIcon';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepperIcon: {
    '& .MuiStepLabel-iconContainer': {
      '& .MuiStepIcon-root': {
        width: '35px !important',
        height: '35px !important',
      },
    },
    '& .MuiStepIcon-completed': {
      color: '#056c93',
    },
    '& .MuiStepIcon-active': {
      color: '#056c93',
    },
    '& .MuiStepLabel-labelContainer': {
      '& .MuiTypography-root': {
        fontSize: '1rem',
        fontWeight: 'bold',
      },
    },
  },
}));
const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const AddDataManager = ({setValue, exportManager, editExisting, DataManagerAccess}) => {
  const stepperClasses = useStyles();
  const classes = reusableInputStyles();
  const [hidden, setHidden] = useState(false);
  const [labelChanges, setLabelChanges] = useState(false);
  const [steps, setSteps] = useState(['Basic Info', 'Map Record', 'Map Exception Record']);
  const dispatch = useDispatch();
  const {onDirty, onPristine} = useUnsavedChangesWarning();
  const showAlertRef = useRef(false);
  const [activeStep, setActiveStep] = useState(0);
  const {basicInfoData, recordsData, configurationUrl, dockey} = useSelector(
    ({dataManagerGroup}) => dataManagerGroup,
  );
  const type = exportManager ? 'Export' : 'Import';
  const [loading, setIsLoading] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);

  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
  };

  useEffect(() => {
    if (configurationUrl) {
      setIsLoading(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoading(false);
      }
      readData();
    }
  }, [configurationUrl]);
  useEffect(() => {
    if (exportManager) {
      if (labelChanges) {
        const stepName = ['Basic Info', 'Map Record Groups', 'Select Fields', 'Filter Criteria'];
        setSteps(stepName);
      } else {
        const stepName = ['Basic Info', 'Map Records', 'Select Fields', 'Filter Criteria'];
        setSteps(stepName);
      }
    } else {
      if (hidden && labelChanges) {
        const stepName = ['Basic Info', 'Map Record Groups', 'Select Fields', 'Filter Criteria'];
        setSteps(stepName);
      } else if (!hidden && labelChanges) {
        const stepName = ['Basic Info', 'Map Record Groups', 'Map Exception Record'];
        setSteps(stepName);
      } else if (hidden && !labelChanges) {
        const stepName = ['Basic Info', 'Map Records', 'Select Fields', 'Filter Criteria'];
        setSteps(stepName);
      } else {
        const stepName = ['Basic Info', 'Map Records', 'Map Exception Record'];
        setSteps(stepName);
      }
    }
  }, [hidden, labelChanges]);
  const handleNext = (value) => {
    setActiveStep((prevActiveStep) => (value ? Number(value) + 1 : prevActiveStep + 1));
  };
  useEffect(() => {
    if (basicInfoData?.dmCode && !exportManager) {
      dispatch(getRecordMapData(basicInfoData?.dataManagerId));
    }
  }, [basicInfoData]);

  useEffect(() => {
    if (basicInfoData?.dmCode) {
      setLabelChanges(
        basicInfoData?.multiRecordFormat === 'Yes' || basicInfoData?.multiRecordFormat === 'Y',
      );
      setHidden(['Customer Query']?.includes(basicInfoData?.dmType));
      // setActiveStep(basicInfoData?.lastStep || 0);
    }
  }, [basicInfoData]);

  useEffect(() => {
    if (basicInfoData?.dmCode) {
      if (basicInfoData?.isDraft === 'N') {
        setActiveStep(0);
      } else {
        setActiveStep(basicInfoData?.lastStep || 0);
      }
    }
  }, [basicInfoData?.dmCode]);

  const isMultiRecordFormat =
    basicInfoData?.multiRecordFormat === 'Yes' || basicInfoData?.multiRecordFormat === 'Y';
  useEffect(() => {
    if (recordsData?.length > 0 && !exportManager && basicInfoData?.dmType !== 'Customer Query') {
      recordsData.forEach((item) => {
        if (isMultiRecordFormat) {
          dispatch(setParentRecordException(item.masterRecord));
        } else {
          dispatch(setParentRecordException(item.recordCode));
        }
      });
    } else {
      dispatch(setParentRecordException(null));
    }
  }, [recordsData]);

  const handleBack = () => {
    if (showAlertRef.current) {
      dispatch(
        setAlertData({
          showAlert: showAlertRef.current,
          alertCallback: () => {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
          },
        }),
      );
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const changeDirty = useRef(true);
  const handleDirty = (dirty, isFixed) => {
    if (isFixed === 'fixed') {
      showAlertRef.current = dirty;
      changeDirty.current = false;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
    if (isFixed === 'reset') {
      showAlertRef.current = false;
      changeDirty.current = true;
      onPristine();
    }
    if (changeDirty.current) {
      showAlertRef.current = dirty;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
  };
  const alertProps = {
    showAlertRef,
    handleDirty,
  };

  const getStepContent = (stepIndex) => {
    const DMSelectFieldComp = (
      <DMSelectField
        handleBack={handleBack}
        handleNext={handleNext}
        exportManager={exportManager}
        editExisting={editExisting}
        DataManagerAccess={DataManagerAccess}
        {...alertProps}
      />
    );
    const DMFilterCriteriaComp = (
      <DMFilterCriteria
        handleBack={handleBack}
        handleNext={handleNext}
        exportManagerRecord={exportManager}
        setValue={setValue}
        isDataManager={true}
        editExisting={editExisting}
        DataManagerAccess={DataManagerAccess}
        {...alertProps}
      />
    );
    switch (stepIndex) {
    case 0:
      return (
        <DMBasicInfo
          activeStep={activeStep}
          handleNext={handleNext}
          exportManager={exportManager}
          handleLabelChange={(e) => setLabelChanges(e)}
          handleHideStep={(e) => setHidden(e)}
          editExisting={editExisting}
          DataManagerAccess={DataManagerAccess}
          {...alertProps}
        />
      );
    case 1:
      return (
        <MapRecordGroup
          handleBack={handleBack}
          exportManager={exportManager}
          labelChanges={labelChanges}
          handleNext={handleNext}
          setValue={setValue}
          hidden={hidden}
          {...alertProps}
          DataManagerAccess={DataManagerAccess}
          editExisting={editExisting}
        />
      );
    case 2:
      if (exportManager || hidden) {
        return DMSelectFieldComp;
      }
      return (
        <MapExceptionRecord
          handleBack={handleBack}
          exportManager={exportManager}
          labelChanges={labelChanges}
          handleNext={handleNext}
          setValue={setValue}
          hidden={hidden}
          editExisting={editExisting}
          DataManagerAccess={DataManagerAccess}
          {...alertProps}
        />
      );
    case 3:
      if (exportManager || hidden) {
        return DMFilterCriteriaComp;
      }
      return DMSelectFieldComp;
    case 4:
      return DMFilterCriteriaComp;
    }
  };
  const isCurrentStepCompleted = basicInfoData?.isDraft === 'N';
  return (
    <>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={exportManager ? 'Export Manager' : 'Import Manager'}
        name={exportManager ? 'Export Manager Name' : 'Import Manager Name'}
        code={basicInfoData?.dmCode}
        description={exportManager ? 'Export Manager Description' : 'Import Manager Description'}
        descriptionValue={basicInfoData?.dmDescription}
      />
      <div className="button-table-spacing-mb justify-content-between new-standard-textfields">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn ${classes.buttonRoot}`}
          onClick={() => {
            if (showAlertRef.current) {
              dispatch(
                setAlertData({
                  showAlert: showAlertRef.current,
                  alertCallback: () => {
                    setValue(0);
                  },
                }),
              );
            } else {
              setValue(0);
            }
          }}
        >
          <ArrowBack className="mr-2" />
          {backButtonText}
        </Button>
        {basicInfoData?.dmCode && (
          <div>
            <Button
              type="button"
              variant="outlined"
              className={`search-btn ml-2 ${classes.buttonRoot}`}
              onClick={() => {
                dispatch(
                  postPrintImportMaster(
                    {
                      dmCode: basicInfoData?.dmCode ? basicInfoData?.dmCode : '',
                      createdDate: basicInfoData?.createdDate ?
                        moment(basicInfoData?.createdDate).format('MM/DD/YYYY') :
                        '',
                      dmType: basicInfoData?.dmType ? basicInfoData?.dmType : '',
                      dmDescription: basicInfoData?.dmDescription ?
                        basicInfoData?.dmDescription :
                        '',
                      isDraft: basicInfoData?.isDraft?.key ? basicInfoData?.isDraft?.key : '',
                      createdFor: basicInfoData?.createdFor?.userName ?
                        basicInfoData.createdFor?.userName :
                        '',
                      orderBy: '',
                      orderDirection: '',
                      type: type,
                      printIndividual: 'Y',
                    },
                    type,
                  ),
                );
              }}
            >
              {downloadButton}
            </Button>
          </div>
        )}
      </div>

      <div className={classes.root} style={{border: '1px solid #cfcfcf'}}>
        <Stepper activeStep={activeStep} connector={<QontoConnector />}>
          {steps.map((label, index) => (
            <Step
              key={label}
              completed={
                index < basicInfoData?.lastStep || isCurrentStepCompleted || index <= activeStep
              }
              style={{cursor: 'pointer'}}
              onClick={() => {
                if (
                  index < activeStep ||
                  index < basicInfoData?.lastStep ||
                  isCurrentStepCompleted
                ) {
                  if (showAlertRef.current) {
                    dispatch(
                      setAlertData({
                        showAlert: showAlertRef.current,
                        alertCallback: () => {
                          setActiveStep(index);
                        },
                      }),
                    );
                  } else {
                    setActiveStep(index);
                  }
                } else if (index < activeStep) {
                  setActiveStep(index);
                }
              }}
            >
              <StepLabel
                className={`${stepperClasses.stepperIcon} ${
                  activeStep === index ? 'completedStyle' : null
                }`}
                StepIconComponent={NumberStepIcon}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <div>
          <div style={{padding: '1.2rem 0.5rem'}}>{getStepContent(activeStep)}</div>
        </div>
      </div>
      {loading && <PageLoader />}
    </>
  );
};

export default AddDataManager;
